import { create } from 'zustand';

import { syncStakeholderDocumentPermission } from '../../guards/sync-stakeholder-document-permission';
import { Company } from '../../types/company.types';

type SelectedCompanyState = {
  company: Company | null;
  companyId: string;
  setCompany: (value: Company) => void;
  setCompanyId: (value: string) => void;
};

export const selectedCompanyStorage = create<SelectedCompanyState>()((set, get) => ({
  company: null,
  companyId: '',
  setCompany: (next) => {
    const prev = get().company;
    if (prev === next) return;
    set({ company: next, companyId: next.id });
    syncStakeholderDocumentPermission(next);
  },
  setCompanyId: (newCompanyId) =>
    set((state) => {
      const nextCompany = state.company?.id === newCompanyId ? state.company : null;
      syncStakeholderDocumentPermission(nextCompany);
      return {
        companyId: newCompanyId,
        company: nextCompany,
      };
    }),
}));
